import { useKeydown } from '@btime/react-hooks'
import React, { useRef } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import GalleryHandler, { useGalleryActions, useGalleryState } from './GalleryHandler'
import GalleryItemThumb from './GalleryItemThumb'
import ZoomModal from './ZoomModal'

const Gallery = ({ children, colWidth, thumbHeight, gap, widthOnSm }) => {
  const { selected, options } = useGalleryState()
  const { setSelected, goToPrevImage, goToNextImage } = useGalleryActions()

  const wrapperRef = useRef()
  useKeydown(wrapperRef, { keys: ['ArrowLeft'], action: goToPrevImage, watch: [selected, setSelected] })
  useKeydown(wrapperRef, { keys: ['ArrowRight'], action: goToNextImage, watch: [selected, setSelected] })

  if ((!options || !options.length) && !children) return false

  return (
    <div ref={wrapperRef} className="gallery">
      <Grid gap={gap || 1} justify="flex-start" align="flex-start" wrap>
        {options.map((item, index) => (
          <Col key={item.value + index} width={colWidth || '33%'} widthOnSm={widthOnSm || '100%'} wrapOn="sm">
            <GalleryItemThumb item={item} thumbHeight={thumbHeight} />
          </Col>
        ))}

        {children}
      </Grid>
    </div>
  )
}

const Wrapper = ({ items, onRemove, onChange, useRotation, ...props }) => (
  <GalleryHandler items={items} onRemove={onRemove} onChange={onChange}>
    <Gallery {...props} />
    <ZoomModal useRotation={useRotation} />
  </GalleryHandler>
)

export default Wrapper
